module.exports = __webpack_public_path__ + "img/print-sptj.85c98d45.svg";